import theme from './theme'
import colors from './colors'

export { theme, colors }

export default theme